module.exports = __webpack_public_path__ + "static/pattern-coulumn-by-percentage-1486ec2b14e626ca8346d930dbeba069.png";